export default {
      id: "documents-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#documents",
      toString: function () {
        return this.url;
      }
    }